import {
  FAQS,
  AnalyticsHeader,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
  REGISTRATION_TERMS_AND_CONDITION,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const riverhounds_pass: TTeamConfig = {
  TEAM_SCHEMA: "riverhounds_pass",
  TEAM_FULL_NAME: "Pittsburgh Riverhounds",
  BROWSER_TITLE: "Riverhounds Pass",
  CLIENT_ID: "5b2d9aa08dde.seasonshare.riverhoundssc-riverhoundssc.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#000000",
    COLORS_SECONDARY: "#FFC72A",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },
    IS_INTERCOM_ENABLED: true,
    ANALYTICS_HEADER: AnalyticsHeader,
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      HIDE_PASS_DETAILS: true,
    },

    SHOW_ALL_PASSES_UNDER_BANNER: true,

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Purchase Now",
      SHOW_FAQ_BUTTON: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
      ATTEND_BUTTON_COLOR: "#FFC72A",
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <REGISTRATION_TERMS_AND_CONDITION />,
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://s3.us-east-2.amazonaws.com/ss-leagues/USL/Riverhounds/pittsburgh-riverhounds-logo.png",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://s3.us-east-2.amazonaws.com/ss-leagues/USL/Riverhounds/pittsburgh-riverhounds-background.jpg",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PRE_PURCHASE_FAQS: FAQS,
    PASS_PURCHASE_SUCCESS_MESSAGE,
  },
};
